import AOS, { AosOptions, AosEvent } from "aos";
import { CountUp, CountUpOptions } from "countup.js";
import { isCrawlerUserAgent } from "is-web-crawler";

class Animations {
  static initEvents() {
    if (isCrawlerUserAgent()) {
      Array.from(document.querySelectorAll("[data-aos]") ?? []).forEach((aosElement) => {
        if (!(aosElement instanceof HTMLElement)) {
          return;
        }

        if (aosElement.dataset.aos) {
          aosElement.dataset.noAos = aosElement.dataset.aos;
          aosElement.dataset.aos = "false";
        }
      });

      return;
    }

    const aosParams: AosOptions = {
      duration: 1000,
      once: true,
    };
    AOS.init(aosParams);
    document.addEventListener("aos:in", this.onAosInCountUpEvent);
  }

  private static onAosInCountUpEvent = (e: AosEvent) => {
    // Cast Element as HTMLElement
    const el = <HTMLTableElement>e.detail;

    // Check is count-up event, or eventType is "aos:in:count-up"
    if (el.dataset.aosId === "count-up") {
      const stat: null | HTMLElement = el.querySelector("[data-figure]");

      if (!stat || stat.dataset.figure === "") return;

      const options: CountUpOptions = {
        duration: 2.6,
        easingFn(t, b, c, d) {
          const ts = (t /= d) * t;
          const tc = ts * t;
          return b + c * (tc + -3 * ts + 3 * t);
        },
      };

      if (typeof stat.dataset.figure !== "undefined") {
        const number = stat.dataset.figure.replace(/[^\d\.\-]/g, "");

        options.decimalPlaces = (number.indexOf(".") === -1) ? 0 : number.split(".")[1].length;

        if (typeof stat.dataset.prefix !== "undefined") {
          options.prefix = stat.dataset.prefix;
        }

        if (typeof stat.dataset.suffix !== "undefined") {
          options.suffix = stat.dataset.suffix;
        }

        const demo = new CountUp(stat, parseFloat(number), options);

        if (!demo.error) {
          demo.start();
        } else {
          console.debug(demo.error);
        }
      } else {
        console.log("[Animations] countUp num undefined");
      }
    }
  }
}

Animations.initEvents();
